const RESTRICTED_ROLE_HIERARCHIES = new Set([1, 2]);
export const buildDefaultTaskFilters = (restrictedAssigneeId) => ({
    search: "",
    status: "",
    priority: "",
    parent: "",
    ref_fonciere: "",
    ...(restrictedAssigneeId ? { assignees: [restrictedAssigneeId] } : {}),
});
/**
 * Ensures that restricted users (role hierarchies 1 & 2) only query tasks assigned to them.
 * The function keeps existing filters but overrides the assignee filter when necessary.
 */
export const enforceRestrictedAssigneeFilter = (filters, user) => {
    if (!user ||
        !user.id ||
        !user.role_hierarchy ||
        !RESTRICTED_ROLE_HIERARCHIES.has(user.role_hierarchy)) {
        return filters;
    }
    const restrictedAssigneeId = user.id.toString();
    const currentAssignees = Array.isArray(filters.assignees)
        ? filters.assignees
        : [];
    if (currentAssignees.length === 1 && currentAssignees[0] === restrictedAssigneeId) {
        return {
            ...filters,
            assignees: currentAssignees,
        };
    }
    return {
        ...filters,
        assignees: [restrictedAssigneeId],
    };
};
export const isRestrictedToOwnTasks = (user) => {
    return Boolean(user &&
        user.id &&
        user.role_hierarchy &&
        RESTRICTED_ROLE_HIERARCHIES.has(user.role_hierarchy));
};
export const getRestrictedAssigneeId = (user) => {
    return isRestrictedToOwnTasks(user) ? user.id.toString() : undefined;
};
